var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',{staticClass:"g-wrapper g-vertical-block"},[_c('Content',{staticClass:"g-main-wrapper g-vertical-block"},[_c('div',{staticClass:"c-content"},[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }